import { DimensionCubeFields, emptyDimensions, type DimensionValue } from "./DimensionCubeFields";

export interface CustomItemDetailsValue extends DimensionValue {
  containerType: string;
  color: string;
}

export function newCustomItemDetails(inventoryType = "MISC"): CustomItemDetailsValue {
  const labels: Record<string, string> = { BOX: "Box", CRATE: "Crate", TOOL: "Toolbox / tool case", EQUIP: "Equipment case", FURN: "Furniture", ELEC: "Electronics", MISC: "Custom item" };
  return { containerType: labels[inventoryType] || "Custom item", color: "", ...emptyDimensions() };
}

export function customItemDetailsFromRecord(
  containerType: string | null,
  color: string | null,
  dimensions: DimensionValue,
  inventoryType = "MISC"
): CustomItemDetailsValue {
  const defaults = newCustomItemDetails(inventoryType);
  return { containerType: containerType || defaults.containerType, color: color || "", ...dimensions };
}

export function customItemPayload(value: CustomItemDetailsValue) {
  return {
    container_type: value.containerType.trim() || null,
    container_color: value.color.trim() || null,
    lid_color: null,
    length: value.length || null,
    width: value.width || null,
    height: value.height || null
  };
}

export function CustomItemDetailsFields({ value, onChange }: { value: CustomItemDetailsValue; onChange: (next: CustomItemDetailsValue) => void }) {
  return (
    <fieldset className="tote-details-fields">
      <legend>Custom item details</legend>
      <div className="form-grid two">
        <label>Container or item type<input value={value.containerType} onChange={(event) => onChange({ ...value, containerType: event.target.value })} placeholder="Toolbox, wooden crate, equipment case" /></label>
        <label>Item color<input value={value.color} onChange={(event) => onChange({ ...value, color: event.target.value })} placeholder="Red, silver, natural wood…" /></label>
      </div>
      <DimensionCubeFields value={value} onChange={(dimensions) => onChange({ ...value, ...dimensions })} />
    </fieldset>
  );
}
